import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const FacebookIcon = ({ color = 'white' }: { color?: string }) => {
	return (
		<Icon
			width="auto"
			height={{ base: '9px', hashup: '10px' }}
			viewBox="0 0 9 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.91129 0H6.68548C5.70162 0 4.75805 0.39084 4.06235 1.08654C3.36665 1.78224 2.97581 2.72581 2.97581 3.70968V5.93548H0.75V8.90323H2.97581V14.8387H5.94355V8.90323H8.16935L8.91129 5.93548H5.94355V3.70968C5.94355 3.5129 6.02172 3.32419 6.16086 3.18505C6.3 3.04591 6.48871 2.96774 6.68548 2.96774H8.91129V0Z"
				fill={color}
			/>
		</Icon>
	);
};
